import { enqueueSnackbar } from "notistack";
import BaseSnackbar from "./base.component";

export default function FailSnackbar(title?: string) {
  return enqueueSnackbar(title || "항목 추가 실패", {
    content: (key, message) => (
      <BaseSnackbar key={key} message={message} severity="error" />
    ),
  });
}
